var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 52,
    rx: 5,
    fill: "#3397F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_533_10457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.847 18.6808L17.2632 28.2632C17.1791 28.348 17.1184 28.4532 17.0872 28.5685L15.0247 36.131C14.9928 36.2479 14.9924 36.3712 15.0235 36.4884C15.0546 36.6055 15.1161 36.7124 15.2019 36.7981C15.2876 36.8838 15.3944 36.9454 15.5116 36.9765C15.6287 37.0076 15.7521 37.0071 15.869 36.9752L23.4315 34.9127C23.5468 34.8816 23.652 34.8209 23.7367 34.7367L33.3191 25.153L26.847 18.6808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3964 19.1594L32.8407 15.6036C32.4539 15.217 31.9294 14.9998 31.3825 14.9998C30.8356 14.9998 30.3111 15.217 29.9243 15.6036L28.3059 17.222L34.778 23.6941L36.3964 22.0758C36.7831 21.689 37.0003 21.1645 37.0003 20.6176C37.0003 20.0707 36.7831 19.5462 36.3964 19.1594Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_533_10457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.34514b36e44dad3f4593ed42c6e67907.svg";
export { ForwardRef as ReactComponent };